// src/pages/Pedido/ResumoItensPedido.js
import React from 'react';
import { BsDot } from 'react-icons/bs';
import { formatCurrency, formatQuantity } from '../../utils/numberUtils';
import { formatPedidoItemConjuntoQuantidade, getPedidoItemConjuntosAgrupados } from '../../utils/pedidoItemConjuntoUtils';

const ResumoItensPedido = ({ pedido }) => {
  const itens = Array.isArray(pedido?.pedidoItens) ? pedido.pedidoItens : [];

  return (
    <>
      <h4>Itens do Pedido</h4>
      {itens.length === 0 ? (
        <p>Nenhum item encontrado.</p>
      ) : (
        <ul className="resumo-itens-lista">
          {itens.map((item) => {
            const adicionais = Array.isArray(item.pedidoItemAdicionais) ? item.pedidoItemAdicionais : [];
            const conjuntosSelecionados = Array.isArray(item.pedidoItemConjuntos) ? item.pedidoItemConjuntos : [];
            const conjuntos = getPedidoItemConjuntosAgrupados(conjuntosSelecionados);

            return (
              <li key={item.id} className="resumo-item">
                <div className="resumo-item-cabecalho">
                  <div className="resumo-item-identificacao">
                    <span className="resumo-item-quantidade">{formatQuantity(item.qtde)}×</span>
                    <strong>{item.produto?.descricao || 'Produto'}</strong>
                  </div>
                  <strong className="resumo-item-total">{formatCurrency(item.valorTotal)}</strong>
                </div>

                {item.apresentacao && <p className="resumo-item-apresentacao">{item.apresentacao}</p>}
                {item.variacao && (
                  <p className="resumo-item-variacao">
                    <span>{item.produto?.variacao?.descricao || 'Variação'}:</span> {item.variacao}
                  </p>
                )}

                {adicionais.length > 0 && (
                  <div className="resumo-item-grupo">
                    <h5>Adicionais</h5>
                    <ul className="resumo-item-opcoes">
                      {adicionais.map((adicional, index) => (
                        <li key={adicional.id ?? index}>
                          <span>+ {adicional.descricao || 'Adicional'}</span>
                          {adicional.valor > 0 && <span className="resumo-item-extra-valor">+ {formatCurrency(adicional.valor)}</span>}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {conjuntos.map((conjunto) => (
                  <div key={conjunto.nomeConjunto} className="resumo-item-grupo">
                    <h5>{conjunto.nomeConjunto}</h5>
                    <ul className="resumo-item-opcoes">
                      {conjunto.itens.map((conjuntoItem, index) => (
                        <li key={conjuntoItem.id ?? index}>
                          <span>{formatPedidoItemConjuntoQuantidade(conjuntoItem, conjuntosSelecionados)} {conjuntoItem.descricao || 'Item do conjunto'}</span>
                          {conjuntoItem.valorAdicional > 0 && (
                            <span className="resumo-item-extra-valor">+ {formatCurrency(conjuntoItem.valorAdicional)}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}

                {/* Renderizar sabor se existir */}
                {item.pedidoItemSabores && item.pedidoItemSabores.length > 0 && (
                  <div className="resumo-item-grupo">
                    <h5>Sabores</h5>
                    <ul className="resumo-item-opcoes">
                      {item.pedidoItemSabores.map((sabor, index) => (
                        <li key={sabor.id ?? index}><BsDot aria-hidden="true" />{sabor.sabor?.descricao}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {item.observacao && (
                  <p className="resumo-item-observacao"><strong>Observação do item:</strong> {item.observacao}</p>
                )}
              </li>
            );
          })}
        </ul>
      )}

      {pedido?.observacao?.trim() && (
        <div className="resumo-observacao-pedido">
          <h4>Observação do pedido</h4>
          <p>{pedido.observacao.trim()}</p>
        </div>
      )}
    </>
  );
};

export default ResumoItensPedido;
